import {Pipe, PipeTransform} from '@angular/core';
import {Checkpoint} from '../classes/checkpoint';
import {CheckpointStatusOrbsEnum} from '../classes/checkpoint-status-orbs.enum';
import {end} from '@popperjs/core';

@Pipe({
    name: 'CheckpointLevelStatusPipe'
})
export class CheckpointLevelStatusPipe implements PipeTransform {

    transform(level: string, checkpoint: Checkpoint): string {
        const now = new Date();
        const endDate = new Date(checkpoint.end_date ?? now);
        const startDate = new Date(checkpoint.start_date ?? now);
        if (startDate > now || endDate < now) {
            return CheckpointStatusOrbsEnum.disabled;
        }

        if (checkpoint.checkpoint_results_count === 0) {
            return CheckpointStatusOrbsEnum.inactive;
        }

        const lastInstance = checkpoint.checkpoint_result_last_instance ? checkpoint.checkpoint_result_last_instance : null;
        const formatedLastInstance = lastInstance ? new Date(lastInstance?.created_at) : null;
        const timeBehind = new Date();
        timeBehind.setDate(timeBehind.getDate() - 1);

        if (checkpoint.error || lastInstance !== null && formatedLastInstance < timeBehind) {
            return CheckpointStatusOrbsEnum.error;
        }

        if (checkpoint?.ssl_valid_till) {
            const sslState = this.sslValidUntil(level, checkpoint);
            if (sslState !== '') {
                return sslState;
            }
        }

        if (checkpoint.warning) {
            return CheckpointStatusOrbsEnum.warning;
        }

        if (checkpoint?.postponed_till) {
            const postponedDate = new Date(checkpoint?.postponed_till || '');
            const now = new Date();
            if (postponedDate > now) {
                return CheckpointStatusOrbsEnum.alert;
            }
        }

        return CheckpointStatusOrbsEnum.success;
    }

    private sslValidUntil(level: string, checkpoint: Checkpoint) {
        const formattedExpiryDate = new Date(checkpoint?.ssl_valid_till);
        const fiveDaysToGo = new Date();
        const oneWeekToGo = new Date();
        const tenDaysToGo = new Date();
        const twoWeeksToGo = new Date();

        fiveDaysToGo.setDate(fiveDaysToGo.getDate() + 5);
        oneWeekToGo.setDate(oneWeekToGo.getDate() + 7);
        tenDaysToGo.setDate(tenDaysToGo.getDate() + 10);
        twoWeeksToGo.setDate(twoWeeksToGo.getDate() + 14);

        if (level === 'production' && formattedExpiryDate <= fiveDaysToGo) {
            return CheckpointStatusOrbsEnum.error;
        } else if (level === 'health' && formattedExpiryDate <= oneWeekToGo) {
            return CheckpointStatusOrbsEnum.error;
        } else if (level === 'health' && formattedExpiryDate <= tenDaysToGo) {
            return CheckpointStatusOrbsEnum.warning;
        } else if (level === 'check' && formattedExpiryDate <= twoWeeksToGo) {
            return CheckpointStatusOrbsEnum.warning;
        }

        if (level === 'acceptance') {
            if (formattedExpiryDate <= oneWeekToGo) {
                return CheckpointStatusOrbsEnum.error;
            } else if (formattedExpiryDate <= twoWeeksToGo) {
                return CheckpointStatusOrbsEnum.warning;
            }
        }

        return '';
    }
}
